import MenuDataAnalytics from "../MenuDataAnalytics";
import Footer from "../Footer";
import NavbarTop from "../NavbarTop";
import MenuInicioRapido from "../MenuInicioRapido";
import React, { useEffect, useState } from "react";
import PesquisaArtigo from "../PesquisaArtigo";

export default function ComoConhecerMeuCliente() {
  const [showScrollButton, setShowScrollButton] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScrollButton && window.pageYOffset > 400) {
        setShowScrollButton(true);
      } else if (showScrollButton && window.pageYOffset <= 400) {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", checkScrollTop);

    return () => {
      window.removeEventListener("scroll", checkScrollTop);
    };
  }, [showScrollButton]);

  useEffect(() => {
    // Rola a página para o topo sempre que a página é carregada
    window.scrollTo(0, 0);
  }, []); // Executa o efeito apenas uma vez, quando o componente é montado

  return (
    <>
      <section>
        <div>
          <NavbarTop />
        </div>

        <div className="container col-md-11">
          <div className="row content section paddingt-2 white-background">
            <div className="col-md-12">
              <nav aria-label="breadcrumb" role="navigation">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="/data-analytics">Data Analytics</a>
                  </li>
                  <li className="breadcrumb-item active">
                    Como conhecer meu cliente?
                  </li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="row justify-content-between">
            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuDataAnalytics />
            </div>

            <div className="col-md-6">
              <h1 className="article-heading">Como conhecer meu cliente?</h1>
              <hr />

              <div className="row justify-content-between" id="article-meta">
                <div className="author col-6 pl-5">
                  <span className="author-name">Data Analytics</span>
                </div>
                <small className="col-6 text-right pr-5">
                  Conheça seu cliente
                </small>
              </div>
              <hr />

              <div className="content article-content">
                <br></br>

                <p>
                  <h3>
                    Entendimento Sócio Demográfico e Psicográfico da sua base de
                    dados
                  </h3>
                </p>

                <p>
                  Para qualquer empresa, independentemente do seu tamanho ou
                  setor de atuação, o entendimento profundo do público-alvo é um
                  dos pilares fundamentais para o sucesso.
                </p>

                <p>
                  É por meio desse conhecimento que as empresas podem tomar
                  decisões estratégicas, desenvolver produtos ou serviços mais
                  relevantes e eficazes, e criar campanhas de marketing mais
                  direcionadas.
                </p>

                <p>
                  Duas categorias de informações desempenham um papel crucial
                  nesse processo: as informações demográficas e psicográficas
                  dos clientes.
                </p>

                <figure>
                  <img
                    src="img/iceberg.png"
                    alt="excel"
                    style={{ display: "block", margin: "0 auto" }}
                  />
                </figure>

                <figcaption>Micro Level - Psicográficas</figcaption>

                <p>
                  As informações demográficas referem-se a características
                  básicas e mensuráveis da população, como idade, sexo, renda,
                  localização geográfica, estado civil e nível educacional.
                </p>

                <p>
                  As informações psicográficas se aprofundam nas características
                  psicológicas e comportamentais dos clientes. Isso inclui
                  valores, crenças, estilo de vida, interesses, hábitos de
                  compra e motivações.
                </p>

                <p>
                  Compreender esses aspectos fornecem uma base sólida para
                  segmentar e compreender o público de uma empresa.<a> </a>
                  <a
                    href="/o-que-sao-as-informacoes-psicograficas-da-sales-box"
                    target="blank"
                  >
                    Clique aqui
                  </a>{" "}
                  para saber mais sobre as informações psicográficas da
                  <a href="https://salesbox.com.br/" target="blank">
                    {" "}
                    Sales Box
                  </a>{" "}
                  .
                </p>

                <br></br>
              </div>

              {/* Seção de votos */}

              <div>
                <PesquisaArtigo />
              </div>
            </div>

            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuInicioRapido />
            </div>
          </div>
        </div>
      </section>

      {showScrollButton && (
        <a onClick={scrollToTop} className="btn-topo">
          <a style={{ fontSize: "25px" }}>↑</a> Voltar ao Topo
        </a>
      )}

      <Footer />
    </>
  );
}
